module.exports = __webpack_public_path__ + "img/炙黄芪.b10db5ba.jpg";